import {Clear} from '@mui/icons-material'
import {ButtonProps, Button} from '@mui/material'
import React from 'react'

export const CancelButton: React.FC<ButtonProps> = (props) => (
  <Button color={'secondary'} startIcon={<Clear />} {...props} />
)
